/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PortfolioSummaryViewModel } from './PortfolioSummaryViewModel';
import {
    PortfolioSummaryViewModelFromJSON,
    PortfolioSummaryViewModelFromJSONTyped,
    PortfolioSummaryViewModelToJSON,
} from './PortfolioSummaryViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfPortfolioSummaryViewModel
 */
export interface ResultOfPortfolioSummaryViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfPortfolioSummaryViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfPortfolioSummaryViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfPortfolioSummaryViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfPortfolioSummaryViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfPortfolioSummaryViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfPortfolioSummaryViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfPortfolioSummaryViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {PortfolioSummaryViewModel}
     * @memberof ResultOfPortfolioSummaryViewModel
     */
    data?: PortfolioSummaryViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfPortfolioSummaryViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfPortfolioSummaryViewModel interface.
 */
export function instanceOfResultOfPortfolioSummaryViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfPortfolioSummaryViewModelFromJSON(json: any): ResultOfPortfolioSummaryViewModel {
    return ResultOfPortfolioSummaryViewModelFromJSONTyped(json, false);
}

export function ResultOfPortfolioSummaryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfPortfolioSummaryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : PortfolioSummaryViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfPortfolioSummaryViewModelToJSON(value?: ResultOfPortfolioSummaryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': PortfolioSummaryViewModelToJSON(value.data),
        'Count': value.count,
    };
}

